// src/services/eventBus.js
import Vue from 'vue';

// Event Bus instance
export const EventBus = new Vue();
